import { Component, OnInit, } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { getUser, PortalHotToastService, setupUntilDestroy } from '@portal-workspace/grow-ui-library';
import { Subscription } from 'rxjs';
import { DeleteBsaLenderFn, GetBsaExcludedLenderListFn, GetBsaLenderListFn, UpdateBsaExcludedLenderFn, UpdateBsaLenderFn, DeleteBsaExcludedLenderFn, AddBsaLenderFn, AddBsaExcludedLenderFn, isAdmin } from '@portal-workspace/grow-shared-library';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatCardModule } from '@angular/material/card';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipsModule } from '@angular/material/chips';
import { ApplicationService } from '../../service/application.service';
import { LenderTableComponent } from '@portal-workspace/grow-ui-library';
import { OverdraftQuarterlyReviewListComponent } from './overdraft-quarterly-review-list/overdraft-quarterly-review-list.component';

@UntilDestroy({ arrayName: 'subscriptions' })
@Component({
    templateUrl: './bank-statement-analysis-settings.page.html',
    styleUrls: ['./bank-statement-analysis-settings.page.scss'],
    standalone: true,
    imports: [MatCardModule, MatTabsModule, LenderTableComponent, OverdraftQuarterlyReviewListComponent, FlexModule, MatChipsModule, MatCheckboxModule, FormsModule, ReactiveFormsModule, MatDividerModule, MatFormFieldModule, MatInputModule, MatButtonModule]
})
export class BankStatementAnalysisSettingsPage implements OnInit {

  readonly isAdminUser = isAdmin(getUser());
  lenderList: string[] = [];
  excludedLenderList: string[] = [];
  formControlLender!: FormControl<string | null>;
  formControlExcludedLender!: FormControl<string | null>;
  addOnBlur = true;
  subscriptions: Subscription[] = [];
  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  getBsaLenderListFn!: GetBsaLenderListFn;
  getBsaExcludedLenderListFn!: GetBsaExcludedLenderListFn;
  updateBsaLenderFn!: UpdateBsaLenderFn;
  updateBsaExcludedLenderFn!: UpdateBsaExcludedLenderFn;
  deleteBsaLenderFn!: DeleteBsaLenderFn;
  deleteBsaExcludedLenderFn!: DeleteBsaExcludedLenderFn
  addBsaLenderFn!: AddBsaLenderFn;
  addBsaExcludedLenderFn!: AddBsaExcludedLenderFn;

  constructor(
    private formBuilder: FormBuilder,
    private applicationService: ApplicationService,
    private toastService: PortalHotToastService
  ) {
    this.formControlLender = formBuilder.control(null);
    this.formControlExcludedLender = formBuilder.control(null);

    this.getBsaLenderListFn = this.applicationService.getBsaLenderListFn;
    this.getBsaExcludedLenderListFn = this.applicationService.getBsaExcludedLenderListFn;
    this.updateBsaLenderFn = this.applicationService.updateBsaLenderFn;
    this.updateBsaExcludedLenderFn = this.applicationService.updateBsaExcludedLenderFn;
    this.deleteBsaLenderFn = this.applicationService.deleteBsaLenderFn;
    this.deleteBsaExcludedLenderFn = this.applicationService.deleteBsaExcludedLenderFn;
    this.addBsaLenderFn = this.applicationService.addBsaLenderFn;
    this.addBsaExcludedLenderFn = this.applicationService.addBsaExcludedLenderFn;
  }


  ngOnInit(): void {
    setupUntilDestroy(this);

  }

}
